export class ProductBugsReleasesFinderReq {
    ProductFamily: string = '';
    ProductRelease: string = '';
    ListType: ListTypes;
    FunctionalArea: string;
}

export enum ListTypes{
    Bug = 0,
    Release = 1
};